export default "__VITE_ASSET__7c6dc789__"